export default __webpack_public_path__ + "static/media/achieved_tabby.22104e34.png";